import React, {useEffect,memo} from 'react';
import styled from "styled-components";
import {useSelector} from "react-redux";
import {fetchPosts} from "../api/redux/downloads";
import {Col, Container, Row} from "react-bootstrap";
import Title from "../../components/Title";
import {hover} from '../../styles/globalStyleVars'
import {wrapper} from "../api/store";
import {ApiServices} from "../api/network/ApiServices";
import {ApiParamKey} from "../api/network/ApiParamKey";
import {NextSeo} from "next-seo";
import {useRouter} from "next/router";
import {ScrollTrigger} from "gsap/dist/ScrollTrigger";
import {ScrollSmoother} from "gsap/dist/ScrollSmoother";

const MyComponent = ({offset}) => {


    const getPost = useSelector((state) => state.privacyReducer);
    let page_data = getPost?.posts?.data?.page_data
    const router = useRouter();
    const currentUrl = router && router.asPath;
    const banner = getPost?.posts?.data?.sections?.find(f => f?.section_data?.slug === 'banner-about');
    const pathname = useRouter()

    useEffect(() => {
        ScrollTrigger.refresh();

        // Scroll to top when page changes
        window.scrollTo(0, 2);
    }, [pathname]);

    return (
        <>
            <NextSeo
                title={`Privacy Policy | Shanta Securities Limited`}
                description={page_data?.meta_description}
                canonical={"https://www.shantasecurities.com"+currentUrl}
                openGraph={{
                    type: 'website',
                    url: "https://www.shantasecurities.com"+currentUrl,
                    title: page_data?.og_title,
                    description: page_data?.og_description,
                    images: [
                        {
                            url: banner?.images?.list?.[0]?.full_path,
                            width: 800,
                            height: 600,
                            alt: page_data?.og_title,
                        },
                        {
                            url:  banner?.images?.list?.[0]?.full_path,
                            width: 800,
                            height: 600,
                            alt: page_data?.og_title,
                        },
                    ],
                }}
            />
            <StyledComponent>
                <Container>
                    <Row>
                        <Col md={12} className="black pt-200 pb-200">
                            <Title noanim text={'Privacy Policy'}
                                   fontSize={'44'} fontWeight={'400'} margin={'0 0 40px'} lineHeight={'56'}/>
                            <ul>
                                <li>By using the Shanta Securities Limited (SSL) website, Mobile Trade App, Facebook page, LinkedIn page, YouTube channel, and any other digital or social media application and/or platform under different brand names (such as "Shanta Securities Limited","Shanta EasyTrade" and "Shanta EasyX" mobile app), you agree to be bound by these Terms and Conditions. These Terms and Conditions may be modified by us from time to time. By accessing any of these platforms, you confirm that you have the right, authority, and capacity to enter into this agreement and that you are at least 18 years old.

                                    Please carefully read and acknowledge these terms and conditions of use. By accessing any of these platforms, you are agreeing to be bound by them. If you do not agree with these conditions of use, please refrain from accessing or viewing any of these platforms.</li>
                                <li>
                                    To access information through SSL platforms, you must have at least one Account with us and activate your access by providing your registered mobile phone number and agreeing to these Terms and Conditions.
                                </li>
                                <li>
                                    <b>When using the service, you must:
                                    </b><br/>
                                    Use the Service only on Equipment that you own or control and solely for accessing the Service.
                                    Accept these Terms and Conditions without making any amendments to them.
                                    Use the Service on new devices by accepting the Terms & Conditions each time you access the Service.
                                </li>
                                <li>
                                    We reserve the right to make operational changes to the Service and perform maintenance that may limit the availability of the Service at any time. We may offer automatic or manual updates to the system without prior notice to you.
                                </li>
                                <li>
                                    Each time you use the Service, the use of your Security Details authorizes us to act on any received instruction and provide the requested Service. We will consider the use of your Security Details as consent to execute any payment or other instructions given by you using the Service. If necessary, this authorization allows us to debit your Accounts with any amounts we have paid in connection with such Instructions.
                                </li>
                                <li>
                                    You are responsible for ensuring the accuracy and completeness of your Instructions and any information provided to us. If you fail to do so and incur a loss, we will not be liable. Therefore, it is crucial that you exercise caution when issuing any Instruction.
                                </li>
                                <li>
                                    You are responsible for safeguarding your Security Details and must ensure that no other person can see or copy them. You should never access the Service from a computer, mobile phone, or device connected to a public internet Wi-Fi network or access. You will be held accountable if you lose your Equipment or if it is stolen, including any confidential, sensitive, or personal information it contains.
                                </li>
                                <li>
                                    You are responsible for safeguarding your Security Details and must ensure that no other person can see or copy them. You should never access the Service from a computer, mobile phone, or device connected to a public internet Wi-Fi network or access. You will be held accountable if you lose your Equipment or if it is stolen, including any confidential, sensitive, or personal information it contains.
                                </li>
                                <li>
                                    You understand and acknowledge that SSL shall not be held responsible for any mistakes made by the customer, such as selecting the wrong mobile number incorrect account or card, wrong recharge amount, wrong PIN, or any other errors or omissions.
                                </li>
                                <li>
                                    You understand and acknowledge that we cannot guarantee or certify the security of your system/Equipment against internet fraud, hacking, or other actions that could potentially affect it. You acknowledge that you are availing the Service at your own risk, value, and assessment.
                                </li>
                                <li>
                                    You agree to pay all applicable fees and charges incurred for using the SSL platforms, and we reserve the right to modify these fees at our absolute discretion.
                                </li>
                                <li>
                                    The features and functions of the service are made available through a third-party service. Please note that if the third-party service becomes unavailable or your or our access to the third-party service is terminated by the third party, then the service may no longer be accessible to you.
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </StyledComponent>
        </>
    );
};



const StyledComponent = styled.section`
 min-height: 80vh;
  ul,ol{
    li{
      padding-left: 20px;
      position: relative;
      margin-bottom: 20px;
      &:last-child{
        margin-bottom: 0;
      }
      &:after{
        height: 10px;
        width: 10px;
        background:${hover};
        content: '';
        position: absolute;
        left: 0;
        top: 5px;
        border-radius: 50%;
      }
    }
  }
`;

MyComponent.getInitialProps = wrapper.getInitialPageProps((store) => async () => {
    let api_services = ApiServices.SECTIONS;
    let param = {
        [ApiParamKey.TYPE]: 'slug',
        [ApiParamKey.VALUE]: 'downloads',
        [ApiParamKey.GET_SECTION]: 'yes',
        [ApiParamKey.IMAGE]: 'yes',
        [ApiParamKey.POST]: 'yes',
        [ApiParamKey.GALLERY]: 'yes',
    }
    await store.dispatch(fetchPosts([api_services, param]));
});

export default React.memo(MyComponent);
